import * as React from "react";
import HomeHero from "../component/HomeHero";
import ChipList from "../component/ChipList";
import { getUniqueTag, getUniqueCategory } from "../service/productService";
import {
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  const tags = getUniqueTag();
  const categories = getUniqueCategory();

  const tempArr = [
    { text: t("home-block-list1-item1") },
    { text: t("home-block-list1-item2") },
  ];

  return (
    <Container>
      <HomeHero
        post={{
          title: t("home-hero-title"),
          description: t("home-hero-desc"),
          linkText: t("home-hero-link-text"),
          image:
            "https://previews.123rf.com/images/grinvalds/grinvalds1603/grinvalds160300177/56171826-women-s-fashion-and-beauty-objects-and-accessories-on-wooden-floor.jpg",
          imageText: "Home Hero Backgraound Image",
        }}
      />
      <Grid item xs={12} md={6}>
        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
          {t("home-block-title1")}
        </Typography>
        <Paper>
          <List dense={true}>
            {tempArr.map((item, index) => (
              <ListItem key={index}>
                <ListItemText>{item.text}</ListItemText>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
          {t("home-block-title2")}
        </Typography>
        <Paper>
          <ChipList data={categories} />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
          {t("home-block-title3")}
        </Typography>
        <Paper>
          <ChipList data={tags} variant="outlined" />
        </Paper>
      </Grid>
      <Divider />
    </Container>
  );
};

export default Home;
